import { useEffect } from 'react'

/**
 * Cuánto puede estar el modo padres sin que nadie lo toque antes de cerrarse
 * solo. Cinco minutos: lo que tarda en enfriarse un café, no lo que tarda en
 * leerse una pantalla.
 *
 * La amenaza es la que la propia app describe para los niños: la tablet en la
 * encimera, un hermano que pasa. Hasta ahora, un adulto que salía de la cocina
 * a mitad de un ajuste dejaba abierto todo lo que el PIN protege, y lo dejaba
 * hasta que alguien pulsara «Salir». El PIN valía lo que valiera la memoria del
 * adulto.
 */
export const INACTIVIDAD_PADRES_MS = 5 * 60_000

/** Lo que cuenta como «alguien lo está usando». Tocar o teclear; mirar no. */
const SEÑALES = ['pointerdown', 'keydown'] as const

/**
 * Llama a `alExpirar` cuando pasan `ms` sin tocar la pantalla, mientras
 * `activo` sea verdadero. Cada toque vuelve a contar desde cero; dejar de estar
 * activo cancela el reloj sin llamar a nadie.
 *
 * No enseña aviso ni cuenta atrás, a propósito. Si el adulto está delante, está
 * tocando y no expira; si no está, no hay a quién avisar. Lo que se encuentra
 * al volver es la pantalla de «¿Quién eres?», que es exactamente lo que se
 * habría encontrado si hubiera pulsado «Salir».
 */
export function useInactividad(activo: boolean, ms: number, alExpirar: () => void): void {
  useEffect(() => {
    if (!activo) return

    let reloj = window.setTimeout(alExpirar, ms)
    const tocar = (): void => {
      window.clearTimeout(reloj)
      reloj = window.setTimeout(alExpirar, ms)
    }
    for (const señal of SEÑALES) window.addEventListener(señal, tocar, { passive: true })

    return () => {
      window.clearTimeout(reloj)
      for (const señal of SEÑALES) window.removeEventListener(señal, tocar)
    }
  }, [activo, ms, alExpirar])
}
